import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import NewAccordion from "../../../components/NewAccordion";
import { WORDINGS } from "../../../helpers/constants";
import { removeUnderScore } from "../../../helpers/utils";
import styles from "./index.module.css";

const ConfirmationTab = () => {
  const { requestDetails = {} } = useSelector((state) => state.bookingReducer);

  return requestDetails?.booking_confirmation_logs ? (
    <div className={styles["schedule-tab__confirmation-tab"]}>
      {requestDetails?.booking_confirmation_logs?.map((logs, index) => (
        <div
          key={index}
          className={styles["schedule-tab__confirmation-tab_container"]}
        >
          <label>{removeUnderScore(logs?.log_type)}</label>
          <NewAccordion
            title={
              <div
                className={
                  styles["schedule-tab__confirmation-tab__accordion-title"]
                }
              >
                {WORDINGS.STATUS}:
                <label
                  className={
                    logs?.status === "pending"
                      ? styles[
                          "schedule-tab__confirmation-tab__accordion-title-pending"
                        ]
                      : styles[
                          "schedule-tab__confirmation-tab__accordion-title-confirmed"
                        ]
                  }
                >
                  {logs?.status === "confirmed" ? (
                    <>
                      {removeUnderScore(logs?.status)}
                      <IoIosCheckmarkCircleOutline size={25} />
                    </>
                  ) : (
                    `${WORDINGS.CONFIRMATION} ${logs?.status}`
                  )}
                </label>
              </div>
            }
            disabled={logs?.status === "pending" ? true : false}
          >
            <div className={styles["schedule-tab__confirmation-tab__details"]}>
              <label>{`${WORDINGS.UPDATED_BY}: ${logs?.confirmed_by?.name}`}</label>
              <label>{`${WORDINGS.UPDATED_ON}: ${moment(
                logs?.confirmed_on
              ).format("h:mm A, DD-MM-YYYY")}`}</label>
            </div>
          </NewAccordion>
        </div>
      ))}
    </div>
  ) : (
    <div className={styles["schedule-tab__no-item"]}>
      {WORDINGS.NO_CONFIRMATIONS}
    </div>
  );
};

export default ConfirmationTab;
